import { render, staticRenderFns } from "./Relaxation.vue?vue&type=template&id=61dcbc58&scoped=true"
import script from "./Relaxation.vue?vue&type=script&lang=js"
export * from "./Relaxation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dcbc58",
  null
  
)

export default component.exports